import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const NoteText = styled("span")(() => ({
  fontSize: "14px",
  color: colors.gray500
}));

export const NoteWarning = styled("span")(() => ({
  fontSize: "14px",
  color: colors.error500
}));
